import React from "react";
import author from "../assets/author/author.jpg";
import charity from "../assets/charity-icon.png";
import educationSupport from "../assets/education-support.png";
import healthSupport from "../assets/health-support.png";
import rationSupport from "../assets/ration-support.png";
export const StorySection = () => {
  return (
    <div className="relative">
      <div className="absolute z-0 left-0 top-0 md:h-[40%] h-[10%] w-full bg-light-green" />
      <div className="better Story-container relative z-10">
        <h3 className="better__heading home-type-subheading font-roboto">
          <span>
            <i style={{ fontSize: "20px", fontWeight: 600 }}>
              Humanitarian Services
            </i>
          </span>
          <br />
          Khadim Welfare Foundation
        </h3>
        <div className="grid sm:grid-cols-2 md:grid-cols-3 grid-col-1 gap-10 mt-10">
          <div className="md:p-4 p-2 border border-gray-400 sm:h-auto h-max bg-white">
            <img
              className="w-full max-w-[352px] max-h-[240px] h-full mb-4"
              src={rationSupport}
            />
            <h4 className="better__subheading font-roboto">
              KWF MONTHLY RATION
            </h4>
            <div className="better__copy font-roboto text-justify">
              When inflation soars and wages stagnate, families struggle to make
              ends meet. KWF's monthly ration program provides essential
              groceries and supplies worth Rs. 2,000 to ensure no family has to
              sleep hungry.
            </div>
          </div>
          <div className="md:p-4 p-2 border border-gray-400 sm:h-auto h-max bg-white">
            <img
              className="w-full max-w-[352px] max-h-[240px] h-full mb-4"
              src={educationSupport}
            />
            <h4 className="better__subheading font-roboto">
              KWF EDUCATION SUPPORT
            </h4>
            <div className="better__copy font-roboto text-justify">
              KWF is on a mission to revolutionize education in Pakistan by
              providing free, high-quality schooling to underprivileged
              children. Literacy isn't just a number; it's hope for a brighter
              future, and KWF is empowering communities one classroom at a time.
            </div>
          </div>
          <div className="md:p-4 p-2 border border-gray-400 sm:h-auto h-max bg-white">
            <img
              className="w-full max-w-[352px] max-h-[240px] h-full mb-4"
              src={healthSupport}
            />
            <h4 className="better__subheading font-roboto">
              KWF HEALTH SUPPORT
            </h4>
            <div className="better__copy font-roboto text-justify">
              Healthcare is a fundamental right, but for many, it's an
              impossible dream. KWF offers a helping hand, providing access to
              critical healthcare services that save lives and alleviate
              suffering for families in dire need.
            </div>
          </div>
        </div>
        <div className="better-testimonial">
          <div className="better-testimonial__left">
            <div
              className="md:text-9xl text-6xl font-bold font-serif text-[#219D80]"
              style={{
                fontFamily: "sans-serif",
                lineHeight: "0px",
                marginTop: "28px",
              }}
            >
              “
            </div>
            <div className="better-testimonial__quote">
              “The believer's shade on the Day of Resurrection will be his
              charity.”
            </div>
            <div className="better-testimonial__user-container">
              {/* <img src={author} alt='img' width='40px' style={{borderRadius:50}}/> */}
              <div className="better-testimonial__user-info">
                <div className="better-testimonial__name">Prophet —</div>
                <div className="better-testimonial__title">Muhammad (PBH)</div>
              </div>
            </div>
          </div>
          <div className="better-testimonial__right">
            <img src={charity} alt="img" />
          </div>
        </div>
      </div>
    </div>
  );
};
